module.exports = __webpack_public_path__ + "static/media/landing_banner_cn.41f7bce3.png";